export default "__VITE_ASSET__CulTFj1V__"